const namespace = 'bravissimo/page';

export const PAGE_CONTENT_SUCCESS = `${namespace}/PAGE_CONTENT_SUCCESS`;
export const PAGE_CONTENT_FAILURE = `${namespace}/PAGE_CONTENT_FAILURE`;
export const PAGE_CONTENT_REQUEST = `${namespace}/PAGE_CONTENT_REQUEST`;
